import { getPropByPath } from 'element-ui/lib/utils/util'

const DEFAULT_RENDER_CELL = function (row, column, $index) {
  const property = column.property
  const value = property && getPropByPath(row, property).v
  if (column && column.sortFormatter && column.formatter) {
    return column.formatter(row, column, value, $index) || ''
  }
  return value || ''
}

export const getCell = function (event) {
  let cell = event.target

  while (cell && cell.tagName.toUpperCase() !== 'HTML') {
    if (cell.tagName.toUpperCase() === 'TD') {
      return cell
    }
    cell = cell.parentNode
  }

  return null
}

const isObject = function (obj) {
  return obj !== null && typeof obj === 'object'
}

export const orderBy = function (array, columns, sortKey, reverse, sortMethod, sortBy) {
  if (!sortKey && !sortMethod && (!sortBy || (Array.isArray(sortBy) && !sortBy.length))) {
    return array
  }
  if (typeof reverse === 'string') {
    reverse = reverse === 'descending' ? -1 : 1
  } else {
    reverse = (reverse && reverse < 0) ? -1 : 1
  }
  const getKey = sortMethod ? null : function (value, index) {
    const column = columns.find(v => v.property === sortKey)
    return isObject(value) ? DEFAULT_RENDER_CELL(value, column, index) : value
  }
  const compare = function (a, b) {
    if (sortMethod) {
      return sortMethod(a.value, b.value)
    }
    if (typeof a.key === 'number' || typeof b.key === 'number') {
      return a.key - b.key
    }
    return (a.key || '').localeCompare(b.key || '', 'zh')
  }
  return array.map(function (value, index) {
    return {
      value: value,
      index: index,
      key: getKey ? getKey(value, index) : null
    }
  }).sort(function (a, b) {
    let order = compare(a, b)
    // if (!order) {
    //   // make stable https://en.wikipedia.org/wiki/Sorting_algorithm#Stability
    //   order = a.index - b.index
    // }
    return order * reverse
  }).map(item => item.value)
}

export const getColumnById = function (table, columnId) {
  let column = null
  table.columns.forEach(function (item) {
    if (item.id === columnId) {
      column = item
    }
  })
  return column
}

export const getColumnByCell = function (table, cell) {
  const matches = (cell.className || '').match(/el-table_[^\s]+/gm)
  if (matches) {
    return getColumnById(table, matches[0])
  }
  return null
}

export const getRowIdentity = (row, rowKey) => {
  if (!row) {
    throw new Error('row is required when get row identity')
  }
  if (typeof rowKey === 'string') {
    if (rowKey.indexOf('.') < 0) {
      return row[rowKey]
    }
    let key = rowKey.split('.')
    let current = row
    for (let i = 0; i < key.length; i++) {
      current = current[key[i]]
    }
    return current
  } else if (typeof rowKey === 'function') {
    return rowKey(row)
  }
}



// WEBPACK FOOTER //
// ./src/public/components/el-table/src/util.js